import styled from "styled-components";

export const LocationContainer = styled.div`
  margin-top: 5px;
  .ant-pagination {
    align-items: left;
    justify-content: left;
    display: flex;
    width: 100%;
    margin-top: 30px;
  }

  .ant-table-pagination.ant-pagination {
    margin-bottom: 0;
  }

  .ant-pagination-options {
    margin-left: auto;
  }
  .ant-pagination-total-text {
    margin-right: auto;
  }

  .ant-pagination-item {
    border: none;
  }
  .ant-pagination-item-link {
    border: none;
  }

  .pencilEdit {
    color: ${(props) => props.theme["@default-color"]};
    cursor: pointer;
    &:hover {
      color: ${(props) => props.theme["@primary-color-brand"]};
    }
  }
`;

export const ActionContainer = styled.div`
  > button {
    background: transparent;
    border: none;
    justify-content: flex-start;
    align-items: center;
    margin-right: auto;
    display: flex;
    color: ${(props) => props.theme.colors.text};
    &:hover {
      color: ${(props) => props.theme["@primary-color-brand"]};
    }
  }
`;
